export enum TaskStateType {
	Open = 1,
	Expired = 2,
	Completed = 3,
	Cancelled = 4,
	Timed = 5
}